import React, { useEffect, useState } from "react";
import "./CalibrationGameScreens.css";
import ufo from "../../../assets/CalibrationGame/ufo.png";
import ring from "../../../assets/CalibrationGame/ring.svg";
import ConfettiBackground from "./ConfettiBackground";
import { useNavigate } from "react-router-dom";
import { Link, useParams } from "react-router-dom";
import userService from "../../../services/userService.js";
import { Modal } from "antd";

const CalibrationGameScreens = ({ screenType }) => {

  const [showModal, setShowModal] = useState(false);
  const [modalState, setModalState] = useState(true);
  const [isError, setIsError] = useState(false);

  const handleModalEvent = () => {
    setShowModal(false);
  }

  const navigate = useNavigate();
  let { stateType } = useParams();
  const [hideBall, setHideball] = useState(false);

  // screenType= start, success and error
  screenType = stateType;

  useEffect(() => {
    setHideball(false);
    setTimeout(() => {
      setHideball(true);
    }, 3000);
    // remove the existing calibration ID if present
    try {
      localStorage.removeItem("calibrationId")
    } catch (error) {
      console.log(`Unable to find calibrationId in localstorage`);
    }
  }, [screenType]);


  const startGame = async () => {

    // ! navigate("/calibration/game");

    let response
    try {
      response = await userService.startCalibrationProcess();

      if (response.error) {
        console.log(`Start Calibration Error:${response.error}`);
      } else {
        localStorage.setItem("calibrationId", response?.data?.calibrationId);
        navigate("/calibration/game");
      }
    } catch (error) {
      if (error.response.data.message == "Calibration Already Completed") {
        setShowModal(true);
        setIsError(false);
        // navigate("/dashboard")
      }else{
        setShowModal(true);
        setIsError(true);
      }

    }
  }

  return (
    <>
      {showModal && <Modal
        className="warning-modal"
        centered
        footer={false}
        open={modalState}
        onOk={handleModalEvent}
        closable={false}
      >
        <div style={{textAlign:"center", padding:"10px 0 10px 0"}}>
          <h4
            style={{
              fontFamily: "Archivo",
              fontSize:"22px"
            }}
          >
            { isError ? "Oops! Something went wrong!" : "BAAI: Calibration Process Already Completed"}
          </h4>
          <button
            style={{
              fontFamily: "Archivo",
              fontSize: "18px",
              backgroundColor: "#0077CC",
              borderRadius: "6px",
              border:"1px solid white",
              textAlign: "center",
              color: "white",
              marginTop: "10px",
              padding: "3.4px 30px 3.4px 30px",
            }}
            onClick={() => {navigate("/dashboard")}}
          >
            Continue to BAAI Dashboard
          </button>
        </div>
      </Modal>}
      {screenType === "start" && (
        <section className="start-screen-bg">
          <div className="start-screen-content">
            <div>
              <p>
                To start the game <br />
                Click the button below
              </p>{" "}
              <br />
              <button onClick={() => startGame()}>Start Game</button> <br />
              <Link to="/calibration/instructions">How to play</Link>
            </div>
          </div>
          <div>
            {/* <img id="ufo-ring" src={ring} /> */}
            <img id="start-ufo-img" src={ufo} alt="" />
            {/* <div id="trapped-circle"></div> */}
          </div>
        </section>
      )}
      {screenType === "success" && (
        <section style={{ background: "#000" }}>
          <ConfettiBackground />
          {!hideBall && (
            <div>
              <div className="success-screen-bg">
                <div className="d-flex justify-content-between">
                  <div className="sucess-ball"></div>
                  <div className="sucess-ball"></div>
                  <div className="sucess-ball"></div>
                </div>

                <div className="d-flex justify-content-around">
                  <div className="sucess-ball"></div>
                  <div className="sucess-ball"></div>
                </div>

                <div className="d-flex justify-content-between">
                  <div className="sucess-ball"></div>
                  <div className="sucess-ball"></div>
                  <div className="sucess-ball"></div>
                </div>

                <div className="d-flex justify-content-around">
                  <div className="sucess-ball"></div>
                  <div className="sucess-ball"></div>
                </div>

                <div className="d-flex justify-content-between">
                  <div className="sucess-ball"></div>
                  <div className="sucess-ball"></div>
                  <div className="sucess-ball"></div>
                </div>
              </div>
            </div>
          )}

          <div className="start-screen-content">
            <div>
              <p>Congratulations..!</p>
              <small>
                You’ve successfully completed <br /> the calibration task.
              </small>{" "}
              <br />
              <button onClick={() => navigate("/dashboard")}>Go to BAAI Dashboard</button> <br />
              {/* <a href="https://www.youtube.com" target="_newYT">Continue watching YouTube</a> */}
            </div>
          </div>
        </section>
      )}
      {screenType === "error" && (
        <section>
          <div>
            <div className="failed-screen-bg">
              {!hideBall && (
                <>
                  <div className="d-flex justify-content-between">
                    <div className="red-circle"></div>
                    <div className="red-circle"></div>
                    <div className="red-circle"></div>
                  </div>

                  <div className="d-flex justify-content-around">
                    <div className="red-circle"></div>
                    <div className="red-circle"></div>
                  </div>

                  <div className="d-flex justify-content-between">
                    <div className="red-circle"></div>
                    <div className="red-circle"></div>
                    <div className="red-circle"></div>
                  </div>

                  <div className="d-flex justify-content-around">
                    <div className="red-circle"></div>
                    <div className="red-circle"></div>
                  </div>

                  <div className="d-flex justify-content-between">
                    <div className="red-circle"></div>
                    <div className="red-circle"></div>
                    <div className="red-circle"></div>
                  </div>
                </>
              )}
            </div>
          </div>

          <div className="start-screen-content">
            <div>
              <p>Uh Oh..!</p>
              <small>
                The game could not be <br /> completed.
              </small>{" "}
              <br />
              <small
                id="success-p-text"
                style={{ fontSize: "18px", lineHeight: "22px" }}
              >
                Please try again and complete the <br /> task to earn rewards.
              </small>{" "}
              <br />
              <button onClick={() => { navigate("/calibration/start") }}>Restart Game</button> <br />
              <a href="www.youtube.com">Got to BAAI Dashboard</a>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default CalibrationGameScreens;
